import { render, staticRenderFns } from "./IPhoneContactBlock.vue?vue&type=template&id=2d131910&"
import script from "./IPhoneContactBlock.vue?vue&type=script&lang=ts&"
export * from "./IPhoneContactBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports